import { Link, Navigate } from "react-router-dom";
import { HouseFill } from "react-bootstrap-icons";

import Layout from "components/Layout";
import SsoCallback from "pages/SsoCallback";
import LanguageTranslator from "pages/LanguageTranslator";
import LoginRedirect from "pages/LoginRedirect";
import { appConfig } from "shared/app-config";

const createRoutesWithPrefix = (isLoggedIn, prefix) => [
  {
    path: `${prefix}`, // Prefix path
    element: (isLoggedIn || appConfig.SSO_ENABLED === 'false') ? <Layout /> : <LoginRedirect />,
    children: [
      {
        path: "", // Make the home path relative
        index: true,
        element: <LanguageTranslator />,
      },
      {
        path: "*",
        element: <Navigate to="/platform" />,
      },    
    ],
  },
  {
    path: "/callback",
    element: <SsoCallback />,
  },
];

const routes = (isLoggedIn) => {
  return createRoutesWithPrefix(isLoggedIn, "");
};

export default routes;
